<template>
  <section class="PopUp" @click.self="openClosePanel = false">
    <section>
      <i class="closepopup fas fa-times" @click="openClosePanel = false"></i>
      <i>Fonctionnalité en cours de développement</i>
    </section>
  </section>
</template>

<script>
export default {
  name: "popup",

  data: function () {
    return {};
  },
  props: ["open_close"],

  computed: {
    openClosePanel: {
      get() {
        return this.open_close;
      },
      set(val) {
        return this.$emit("update:open_close", val);
      },
    },
  },

  mounted() {},
  methods: {},
};
</script>

<style>
.PopUp {
  background: rgba(100, 100, 100, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.5s ease;
}
@keyframes scaleOnOpen {
  from {
    transform: scale(0);
  }
}
.PopUp > section {
  width: 50%;
  height: 50%;
  box-shadow: 2px 2px 8px 0px #777;
  background: #fefefe;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: scaleOnOpen 0.5s ease;
}
.PopUp i {
  position: absolute;
  cursor: pointer;
  color: #555;
  transition: 0.5s ease;
}
.PopUp i:hover {
  color: #000;
}
.closepopup {
  top: 1rem;
  right: 1rem;
  font-size: 2em;
}

/* @media all and (max-height: 750px) {
	.PopUp > section {
		height: 95%;
	}
} */
</style>
